/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import Auth from "../../shared/Auth";
import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import Alert from "../Alert";
import AppActions from "../AppActions";
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import FormLabel from "../FormLabel";
import Tick from "../Tick";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class ScanQueue extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {},
            scan: {},
            scanHistory: []
        };
    }

    async componentDidMount() {
        await this.load();
    }

    load = async () => {
        await this.fillListAsync('/api/purchase-order/list/out/0', 'purchaseOrders');
    }

    change = (e, resetPO) => {
        let info = { ...this.state.info };
        if (resetPO)
            info.purchaseOrderID = null;
        this.setState({ info: info });
    }

    scan = async (v) => {
        this.setState({ scannedItem: null, errorMessage: null });
        if (!v || v.length < 2)
            return;
        try {
            let j = await qreq.postAsync('/api/inventory/scan', {
                accountID: Number(this.state.po.shipToAccountID),
                lotNumber: v,
                in: false,
                out: true,
                purchaseOrderID: this.state.po.id
            });
            if (j.item) {
                let scanHistory = [...this.state.scanHistory];
                j.item.scanDate = new Date();
                scanHistory.unshift(j.item);
                this.setState({ scan: {}, scannedItem: j.item, scanHistory: scanHistory });
                await this.checkPS();
            }
            else {
                this.setState({ errorMessage: j.errorMessage });
            }
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    checkScan = async () => {
        if (this.state.scan?.barcode !== this.currentScan) {
            this.currentScan = this.state.scan?.barcode;
            await this.scan(this.state.scan.barcode);
        }
    }

    checkPS = async (poID) => {
        if(!poID)
            poID = this.state.po.id;
        await this.fillItemAsync('/api/package-slip/scanned/po/' + poID, 'ps');
    }

    selectPO = (po) => {
        this.setState({ po: po });
        this.checkPS(po.id);
    }

    getPSItemsCount = () => {
        if(!this.state.ps)
            return 0;
        return this.state.ps.items.length;
    }

    
    getPSItemsScannedCount = () => {
        if(!this.state.ps)
            return 0;
        return this.state.ps.items.filter(x => x.lotNumber).length;
    }

    isFilled = () => {
        return this.state.ps && this.getPSItemsScannedCount() >= this.getPSItemsCount();
    }

    render() {
        return (
            <div className="container-fluid">
                <h1>Scan Queue</h1>

                {!this.state.po ? <Card title="Worklist">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Submitted</th>
                                <th>PO</th>
                                <th>Bill To</th>
                                <th>Ship To</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.purchaseOrders?.map((po, idx) => <tr key={idx} role="button"
                                onClick={() => this.selectPO(po)}>
                                <td className="text-primary">{Globals.toMDYHMLocalDateStringOrDiff(po.sentDate)}</td>
                                <td className="text-primary">{po.iid}</td>
                                <td>{po.accountName}</td>
                                <td>{po.shipToAccountName}</td>
                            </tr>)}
                        </tbody>
                    </table>
                </Card>

                    : <>
                    <AppActions onBack={() => this.setState({ po: null })} />
                    <Card title="Scan"
                        headerButtons={<>
                            <button className="btn btn-secondary" onClick={() => this.setState({ po: null })}>Go Back</button>
                        </>}>
                        <FormLabel label="PO" model={this.state.po.iid} />
                        <FormLabel label="Bill To" model={this.state.po.accountName} />
                        <FormLabel label="Ship To" model={this.state.po.shipToAccountName} />
                        <FormLabel label="Progress" model={this.getPSItemsScannedCount() + '/' + this.getPSItemsCount()} />
                        <FormInput
                            model={this.state.scan}
                            label="Barcode"
                            name="barcode"
                            disabled={this.isFilled()}
                        />
                    </Card>
                    </>}

                <Tick onTick={this.checkScan} />
                {this.state.errorMessage && <Alert type="danger" message={this.state.errorMessage} />}
                {this.state.scanHistory?.length > 0 && <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Manufacturer</th>
                            <th>Product</th>
                            <th>Size</th>
                            <th>Catalog Code</th>
                            <th>Lot Number</th>
                            <th>Expiration Date</th>
                            <th>Scan Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.scanHistory.map((item, idx) => <tr key={idx}>
                            <td>{item.manufacturerName}</td>
                            <td>{item.productName}</td>
                            <td>{item.productSize}</td>
                            <td>{item.catalogCode}</td>
                            <td>{item.lotNumber}</td>
                            <td>{item.expirationDate}</td>
                            <td>{Globals.toMDYHMLocalDateStringOrDiff(item.scanDate)}</td>
                        </tr>)}
                    </tbody>
                </table>}

            </div>
        );
    }
}

export default withParamsAndNavigate(ScanQueue);